import { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Pels canvis de pagina
import './LoginPage.css'; // Importem els estils CSS per a aquesta pàgina
import logoImg from '../assets/logo2.png';  // Importem imatges que he guardat a la carpeta assets
import logoImg2 from '../assets/logo-uab.png';
import API_URL from '../config';

function LoginPage() {
  const [username, setUsername] = useState(''); // Estat per a l'usuari
  const [password, setPassword] = useState(''); // Estat per a la contrasenya
  const [error, setError] = useState(''); // Estat per a missatges d'error
  
  const navigate = useNavigate(); // Per redirigir l'usuari a una nova ruta

  const enviaForm = async (e) => { // Funció per gestionar l'enviament del formulari
  e.preventDefault(); // Evita el comportament per defecte del formulari
  setError(''); // Neteja errors previs

      try {
      const response = await fetch(`${API_URL}/api/auth/login/`, { 
        method: 'POST', // Metode que susa per enviar dades 
        headers: {
          'Content-Type': 'application/json', // Tipus de contingut
        },
        credentials: 'include',
        body: JSON.stringify({ username, password }) // Dades enviades a Django
      });

      const data = await response.json(); // Resposta de django convertida a JSON

      if (response.ok) {
        sessionStorage.setItem('token', data.token); // Guarda el token a sessionStorage
        navigate('/dashboard'); // Redirigeix a la pagina de dashboard de moment (pruebas)
      } else {
        setError(data.error || 'Credencials incorrectes.'); // Mostra l'error rebut de Django
      }
    } catch (err) {
      setError('No s\'ha pogut connectar amb el servidor.'); // Error de connexió al servidor backend
    }
  };

  
  return (
    <div className="contenidor-login"> {/* Contenidor principal */}
      <div className="caixa-login"> {/* Caixa del mig on posarem la foto i el formulari */}
        
        {/* PANELL ESQUERRE */}
        <div className="panell-imatge">
          <h1>Optimitza el teu temps, maximitza els teus guanys</h1>
        </div>

        {/* PANELL DRET */}
        <div className="panell-formulari">
          
          <img src={logoImg2} alt="Logo uab" className="logo-cantonada" />
          
          <div className="capçalera-login">
            <div className="marca-empresa">
              <img src={logoImg} alt="FitAnalytics Logo" className="imatge-logo" />
              <span className="nom-empresa">FitAnalytics</span>
            </div>
            <h1>Benvingut/da</h1>
            <p>Gestiona els teus clients i analitza la teva rendibilitat</p>
          </div>
          
          {error && <div className="missatge-error">{error}</div>}

          <form onSubmit={enviaForm}>
            <div className="grup-formulari">
              <label>Usuari</label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="exemple"
                required
              />
            </div>
            
            <div className="grup-formulari">
              <label>Contrasenya</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="********"
                required
              />
            </div>

            <button type="submit" className="boto-login">
              Entra
            </button>
          </form>
        </div>

      </div>
    </div>
  );
}

export default LoginPage;